import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-mentor',
  templateUrl: './home-mentor.component.html',
  styleUrls: ['./home-mentor.component.css']
})
export class HomeMentorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
